import { ActionType } from "../interfaces/api/actionType";

export const GetContracts: ActionType = {
  FAILURE: "GET_CONTRACTS_FAILURE",
  REQUEST: "GET_CONTRACTS_REQUEST",
  SUCCESS: "GET_CONTRACTS_SUCCESS",
};
